import { Icon, Label } from "semantic-ui-react";
import { useTextResources } from "@/language";
import "./CopyRateResultCard.less";

/**
 * @typedef {Object} CopyRateResult
 * @property {number} HotelId - The hotel ID
 * @property {string} HotelName - The hotel name
 * @property {string} RateName - The rate name
 * @property {boolean} Success - Whether the copy was successful
 * @property {string} [ErrorMessage] - Error message if copy failed
 */

/**
 * CopyRateResultCard - Displays the result of a rate copy operation
 * @param {Object} props
 * @param {string} props.hotelName - The name of the target hotel
 * @param {string} props.rateName - The name of the copied rate
 * @param {boolean} props.success - Whether the copy was successful
 * @param {string} [props.errorMessage] - Error message if copy failed
 */
const CopyRateResultCard = ({ hotelName, rate, success, errorMessage }) => {
  const text = useTextResources();

  return (
    <div className={`copy-rate-result-card ${success ? "success" : "error"}`}>
      <Icon
        name={success ? "check circle" : "times circle"}
        size="large"
        className="result-card-icon"
      />

      <div className="result-card-content">
        <div className="result-card-header">
          {hotelName}
          <Label
            size="tiny"
            basic
            color={success ? "teal" : "red"}
            className="result-status-label"
          >
            {success ? text("Success") : text("Failed")}
          </Label>
        </div>
        <div className="result-card-rate-name">
          <span>{rate.Name || "Unknown Rate"}</span>
          <a href={`${window.location.pathname}/Edit?RateId=${rate.Id}`} rel="noopener noreferrer" target="_blank"><Icon name="edit"/></a>
        </div>
        {!success && errorMessage && (
          <div className="result-card-error">{errorMessage}</div>
        )}
      </div>
    </div>
  );
};

export default CopyRateResultCard;
